import Header from './components/Header';
import Hero from './components/Hero';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CommentsSection />
        <AppSection />
        <CardsSection />
        <ContactSection />
        <UpdatesSection />
        <AboutSection />
        <CarouselSection />
        <IndexSection />
        <RankingSection />
        <FaqSection />
        <FeaturesSection />
        <MediaSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}